/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EliminarFarmacoPacienteDto } from '../../models/eliminar-farmaco-paciente-dto';

export interface FarmacosControllerEliminarFarmacoPaciente$Params {
  programaUuid: string;
  farmacoUuid: string;
      body: EliminarFarmacoPacienteDto
}

export function farmacosControllerEliminarFarmacoPaciente(http: HttpClient, rootUrl: string, params: FarmacosControllerEliminarFarmacoPaciente$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, farmacosControllerEliminarFarmacoPaciente.PATH, 'delete');
  if (params) {
    rb.path('programaUuid', params.programaUuid, {});
    rb.path('farmacoUuid', params.farmacoUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

farmacosControllerEliminarFarmacoPaciente.PATH = '/api/farmacos/farmacos-paciente/{programaUuid}/{farmacoUuid}/eliminar';
